import * as yup from 'yup'

export const testimonySchema = yup.object().shape({
    fullname: yup.string().required(),
    dept: yup.string().required(),
    level: yup.string().required(),
    testimony: yup.string().required()
})

export const publicationSchema = yup.object().shape({
    title: yup.string().required(),
    authors: yup.string().required(),
    link: yup.string().url('Invalid Url').required()
})

export const executiveSchema = yup.object().shape({
    fullname: yup.string().required(),    
    office: yup.string().required(),
    deptLevel: yup.string().required()
})

export const staffAdviserSchema = yup.object().shape({
    fullname: yup.string().required(),    
    office: yup.string().required(),
    position: yup.string().required()
})

export const eventsSchema = yup.object().shape({
    picture: yup.string().required(),
    caption: yup.string().required()
})

export const contactSchema = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email('Invalid Email').required(),
    message: yup.string().required()
})

export const assessmentSchema = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email('Invalid Email').required(),    
})

export const newsletterSchema = yup.object().shape({
    email: yup.string().email('Invalid Email Address').required('Required')
})

export const resultSchema = yup.object().shape({
    score: yup.string().required(),
    email: yup.string().email('Invalid Email').required(),    
})

export const quizlinkSchema = yup.object().shape({
    quiz: yup.string().url('Invalid Url').required()
})